import { connect } from 'react-redux';
import { forceMiniPlayerState } from 'actions/player-actions';
import { setHidden } from 'actions/search-actions';
import asContentPage from 'components/hoc/asContentPage';
import withContentfulData from 'components/hoc/withContentfulData';

import FaqCategoryPage from './FaqCategoryPage';

const FaqCategoryPageContainer = connect(null, {
  forceMiniPlayerState,
  setSearchHidden: setHidden,
})(FaqCategoryPage);
export default asContentPage('faqCategory', withContentfulData(FaqCategoryPageContainer));
